import {
  BasicModal,
  CardComponent,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { Grid } from '@mui/material';

export interface EditNotesCheckoffListModalProps {
  name: string;
  note: string;
   
  onChange: (value: string) => void;
  onSave: () => void;
  onClose: () => void;
}

const EditNotesCheckoffListModal: React.FC<EditNotesCheckoffListModalProps> = ({
  name,
  note,
  onChange,
  onSave,
  onClose,
}) => {
  return (
    <BasicModal
      title={name || ''}
      open={true}
      handleClose={onClose}
      width="650px"
      body={
        <CardComponent
          title=""
          mainGridStyles={{
            background: patientAccessTheme.palette.background.default,
          }}
          body={
            <ReportCreateNewLabelField
              label="Edit Note"
              width="100%"
              component={
                <Grid>
                  <TextField
                    value={note}
                    fullWidth
                    height="36px"
                    placeholder="Edit note"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      onChange(e.target.value)
                    }
                  />
                </Grid>
              }
            />
          }
        />
      }
      isConfirmDisabled={note.trim() === ''}
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Save"
      handleCancel={onClose}
      handleConfirm={onSave}
    />
  );
};

export default EditNotesCheckoffListModal;
